import { render, staticRenderFns } from "./getStoreName.vue?vue&type=template&id=0215dd4b&scoped=true&"
import script from "./getStoreName.vue?vue&type=script&lang=js&"
export * from "./getStoreName.vue?vue&type=script&lang=js&"
import style0 from "./getStoreName.vue?vue&type=style&index=0&id=0215dd4b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0215dd4b",
  null
  
)

export default component.exports